// extracted by mini-css-extract-plugin
export default {"checkBoxWrapper":"styles_checkBoxWrapper__SIG75"};